<template>
	<!-- START RESPONSE TYPE API -->
	<div>
		<p class="h5">{{ $t('Request Info') }}</p>

		<div class="form-group">
			<input
				name="api_url"
				v-model="commandResponse.resp_api_url"
				v-validate="commandResponse.resp_type == 'api' ? 'required' : ''"
				:class="{'form-control': true, 'is-invalid': errors.has('api_url')}"
				type="text"
				:placeholder="$t('api_endpoint')"
				autocomplete="off"
			/>
			<span
				v-if="errors.has('api_url')"
				class="help is-danger invalid-feedback"
			>{{ $t(errors.first('api_url')) }}</span>
		</div>

		<div class="form-group">
			<div class="btn-group" role="group">
				<button
					type="button"
					class="btn btn-outline-info m-0"
					v-for="httpMethod in httpMethods"
					:class="{'active text-white': commandResponse.resp_api_req_type.toUpperCase() === httpMethod}"
					:key="`command_response_api_http_${httpMethod}`"
					@click="setHTTPMethodType(httpMethod)"
				>{{ httpMethod }}</button>
			</div>
		</div>

		<tooltip label="Custom Headers" placement="right">
			<textarea
				name="api headers"
				class="form-control"
				v-model="commandResponse.resp_api_headers"
				cols="3"
				:placeholder="$t('Type Custom Headers')"
			></textarea>
		</tooltip>

		<p class="h5">{{ $t('Request Parameters') }}</p>

		<table class="table table-borderless shadow">
			<thead class="bg-primary py-2">
				<tr>
					<th class="text-capitalize">{{ $t('Parameter Name') }}</th>
					<th class="text-capitalize">{{ $t('Parameter Value') }}</th>
					<th class="text-capitalize">{{ $t('Parameter Default Value') }}</th>
					<th class="text-capitalize">{{ $t('Actions') }}</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(apiParamater, index) in commandResponse.resp_api_pars"
					:key="`api-paramter-${index}`"
				>
					<td>
						<input type="text" v-model="apiParamater.name" class="form-control" />
					</td>
					<td>
						<select class="form-control" v-model="apiParamater.var_id">
							<option value="0" disabled>{{ $t('None') }}</option>
							<option v-for="(v, i) in vars" :value="v.var_id" :key="i">{{ v.var_name }}</option>
							<option
								v-for="(senderInfoKey, index) in Object.keys($store.state.sender_info)"
								:value="senderInfoKey"
								:key="'sender_info_' + index"
							>{{ $t($store.state.sender_info[senderInfoKey]) }}</option>
						</select>
					</td>
					<td>
						<input type="text" v-model="apiParamater.var_default_value" class="form-control" />
					</td>
					<td class="text-center">
						<button type="button" class="btn btn-danger btn-sm mx-2">
							<i @click="removeAPIParameter(index)" class="fa fa-trash fa-lg" :title="$t('delete')"></i>
						</button>
					</td>
				</tr>

				<tr>
					<td>
						<input
							type="text"
							v-model="apiParamater.name"
							class="form-control"
							:placeholder="$t('Parameter Name')"
						/>
					</td>
					<td>
						<select class="form-control" v-model="apiParamater.var_id">
							<option value="0" disabled>{{ $t('Parameter Value') }}</option>
							<option v-for="(v, i) in vars" :value="v.var_id" :key="i">{{ v.var_name }}</option>
							<option
								v-for="(senderInfoKey, index) in Object.keys($store.state.sender_info)"
								:value="senderInfoKey"
								:key="'sender_info_' + index"
							>{{ $t($store.state.sender_info[senderInfoKey]) }}</option>
						</select>
					</td>
					<td>
						<input
							type="text"
							v-model="apiParamater.var_default_value"
							class="form-control"
							:placeholder="$t('Parameter Default Value')"
						/>
					</td>
					<td class="text-center">
						<button @click="addAPIParameter" type="button" class="btn btn-success btn-sm mx-2">
							<i class="fa fa-plus fa-lg" :title="$t('Add')"></i>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
	<!-- END RESPONSE TYPE API -->
</template>

<script>
	export default {
		props: {
			commandResponse: {
				type: Object,
				// default: () => {},
			},
		},

		data() {
			return {
				vars: [],
				httpMethods: ['GET', 'POST'],
				apiParamater: {
					name: '', // TODO: ask about this property
					var_name: '',
					var_id: 0,
					var_default_value: '',
				},
			}
		},

		methods: {
			setHTTPMethodType(method) {
				this.commandResponse.resp_api_req_type = method
				this.$emit('saveOptions')
			},

			addAPIParameter() {
				this.commandResponse.resp_api_pars.push(this.apiParamater)
				this.apiParamater = {
					name: '', // TODO: ask about this property
					var_name: '',
					var_id: 0,
					var_default_value: '',
				}
			},
			removeAPIParameter(index) {
				this.commandResponse.resp_api_pars.splice(index, 1)
			},
		},
	}
</script>

<style lang="scss" scoped>
</style>
